var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      editBtn: !_vm.iSEdited && _vm.hasBtn("edit-admin-approval-type"),
      delBtn: _vm.hasBtn("delete-admin-approval-type"),
      backgroundClass: "white",
      initData: _vm.approvalTypeData,
      checkData: [
        "flow_type_name",
        "color_code",
        "flow_type_description",
        "flow_icon",
        "remarks",
      ],
      title: _vm.iSEdited
        ? _vm.$t("label_essweb_approvalType_form_editTitle")
        : _vm.$t("label_essweb_approvalType_form_viewTitle"),
      widthClass: "max-1000",
    },
    on: {
      edit: function ($event) {
        _vm.iSEdited = true
      },
      delete: function ($event) {
        _vm
          .$confirmDo(_vm.$t("label_essweb_approvalType_list_title"))
          .then(function (res) {
            res ? _vm.toDelete() : null
          })
      },
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            maxlength: "100",
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                            bindData: _vm.approvalTypeData.flow_type_name,
                            label: _vm.$t(
                              "label_essweb_approvalType_form_approvalTypeNameLabel"
                            ),
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.approvalTypeData.flow_type_name = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_approvalType_form_tagColorLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("SelectColor", {
                          attrs: {
                            items: _vm.$Colors,
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            appendIcon: _vm.iSEdited ? "arrow_drop_down" : "",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          model: {
                            value: _vm.approvalTypeData.color_code,
                            callback: function ($$v) {
                              _vm.$set(_vm.approvalTypeData, "color_code", $$v)
                            },
                            expression: "approvalTypeData.color_code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            filled: _vm.iSEdited,
                            maxlength: "500",
                            readonly: !_vm.iSEdited,
                            bindData:
                              _vm.approvalTypeData.flow_type_description,
                            label: _vm.$t(
                              "label_essweb_approvalType_form_descriptionLabel"
                            ),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.approvalTypeData.flow_type_description =
                                valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-sheet", { staticClass: "text--secondary" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "label_essweb_approvalType_form_flowIconLabel"
                              )
                            )
                          ),
                        ]),
                        _c("ImgDragUpdate", {
                          attrs: {
                            defaultImageList: _vm.approvalTypeData.attachments,
                            single: "",
                            disabled: !_vm.iSEdited,
                          },
                          on: {
                            change: function (img) {
                              return (_vm.approvalTypeData.attachments = img)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-sheet", { staticClass: "text--secondary" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "label_essweb_approvalType_form_remarkLabel"
                              )
                            )
                          ),
                        ]),
                        _c("v-textarea", {
                          attrs: {
                            rows: "5",
                            "no-resize": "",
                            maxlength: "500",
                            dense: "",
                            counter: "500",
                            "single-line": "",
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                          },
                          model: {
                            value: _vm.approvalTypeData.remarks,
                            callback: function ($$v) {
                              _vm.$set(_vm.approvalTypeData, "remarks", $$v)
                            },
                            expression: "approvalTypeData.remarks",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _vm.iSEdited
              ? _c("CardActions", {
                  attrs: { saveBtn: "" },
                  on: {
                    save: _vm.toSave,
                    cancel: function ($event) {
                      return _vm.$toBack(_vm.isChanged)
                    },
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return undefined
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }